import { Container, Stack } from '@mui/material';
import { navigate } from 'gatsby';
import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { UserAdminControl } from '@components/Admin';
import UploadedRecordsList from '@components/UploadedRecordsList/UploadedRecordsList';

import { CLIENTS } from '@constants/routes';

import { useSession } from '@hooks/useSession';

import { formatName } from '@utils/format';

import MainWrapper from '@views/Records/Common/MainWrapper';

import ClientIds from './IDs';
import PatientRecords from './PatientRecords';
import ClientTabs from './ProfileCard';
import TaskList from './TaskList';

const messages = defineMessages({
  client: {
    id: 'clientProfile.client',
    defaultMessage: 'Client',
  },
});

const ClientProfile: React.FC<{ id?: string }> = ({ id = '' }) => {
  const { formatMessage } = useIntl();
  const {
    state: { isCurator, activeProfile },
  } = useSession();

  useEffect(() => {
    if (!id) {
      navigate(CLIENTS);
    }
  }, [id]);

  const vitall_patient_id = activeProfile?.vitall_patient?.vitall_patient_id;
  const patient_id = activeProfile?.vitall_patient?.patient_id;

  const name = formatName(activeProfile?.first_name, activeProfile?.last_name);

  const loading = !activeProfile;

  return (
    <MainWrapper
      friendlyName={name ?? formatMessage(messages.client)}
      loading={loading}
      title={name ?? ''}
    >
      <Container sx={{ pb: 10 }}>
        <Stack spacing={3}>
          <ClientTabs user_id={id} patient_id={patient_id} />

          {activeProfile && isCurator ? (
            <>
              <ClientIds />
              <PatientRecords />
              <TaskList vitall_patient_id={vitall_patient_id} />
              <UploadedRecordsList curatorView />
              <UserAdminControl.Settings user_id={activeProfile.user_id} />
              <UserAdminControl.DangerZone user={activeProfile} />
            </>
          ) : null}
        </Stack>
      </Container>
    </MainWrapper>
  );
};

export default ClientProfile;
